import { useState, useEffect } from "react";
import { v4 as uuid } from "uuid";
import classNames from "classnames";
import { EMPTY_STRING, INDEX } from "../../../constants";
import { selectedColorIcon, redTrashIcon } from "../../../assets/icons";
import ColorPicker from "../ColoPicker";
import { INTERFACES } from "../../organisms/AppDrawers/drawers.constants";
import { selectSelectedProperty } from "../../../pages/DataModels";
import { useSelector } from "react-redux";
import { useFormikContext } from "formik";
import { get } from "lodash";

const { SELECT, CHECKBOX } = INTERFACES;
const { SECOND } = INDEX;
const OPTIONS_FIELD_NAME = "meta.options";

const Repeater = ({
  fieldType,
  fieldName,
  setFieldValue,
  setFieldTouched = () => {},
}) => {
  const selectedProperty = useSelector(selectSelectedProperty);
  const { values } = useFormikContext();
  const defaultPropertyField = get(values, fieldName, EMPTY_STRING);
  const DEFAULT_VALUE = {
    id: uuid(),
    value: EMPTY_STRING,
    isChecked: false,
  };

  const [propertyValues, setPropertyValues] = useState([
    { ...DEFAULT_VALUE, isChecked: true },
  ]);

  useEffect(() => {
    const defaultProperty = propertyValues.find(
      (property) => property.isChecked
    );
    const defaultValue = defaultProperty ? defaultProperty.value : EMPTY_STRING;
    setFieldValue(fieldName, defaultValue);
  }, [propertyValues, setFieldValue, fieldName, defaultPropertyField]);

  useEffect(() => {
    selectedProperty && setPropertyValues(selectedProperty.meta.options);
  }, [selectedProperty]);

  useEffect(() => {
    setFieldValue(OPTIONS_FIELD_NAME, propertyValues);
  }, [propertyValues, setFieldValue]);

  const handleAddPropertyValue = () =>
    setPropertyValues((prev) => [...prev, DEFAULT_VALUE]);

  const handleDeletePropertyValue = (property) => {
    const filteredPropertyValues = propertyValues.filter(
      (propertyValue) => propertyValue.id !== property.id
    );
    setPropertyValues(filteredPropertyValues);
  };

  const handleOnCheck = (e, valueData) => {
    const updatedValues = propertyValues.map((property) => ({
      ...property,
      isChecked: property.id === valueData.id && e.target.checked,
    }));
    setPropertyValues(updatedValues);
  };

  const handleOnChange = (e, valueData) => {
    const updatedValues = propertyValues.map((property) => ({
      ...property,
      value: property.id === valueData.id ? e.target.value : property.value,
    }));
    setPropertyValues(updatedValues);
    setFieldTouched(OPTIONS_FIELD_NAME, true);
  };

  const renderFieldIcon = (fieldType, propertyValue) => {
    if (fieldType === SELECT)
      return <img src={selectedColorIcon} alt="drag-icon" />;
    else if (fieldType === CHECKBOX)
      return (
        <input
          type="checkbox"
          checked={propertyValue.isChecked}
          onChange={(e) => handleOnCheck(e, propertyValue)}
          className="text-indigo-600 !rounded"
        />
      );
    else
      return (
        <input
          type="radio"
          name="radio"
          checked={propertyValue.isChecked}
          className="text-indigo-600"
          onChange={(e) => handleOnCheck(e, propertyValue)}
        />
      );
  };

  const renderRepeaterProperties = (fieldType, propertyValue, position) => {
    if (fieldType === SELECT)
      return (
        <ColorPicker
          value={propertyValue.value}
          handleChange={(e) => handleOnChange(e, propertyValue)}
        />
      );
    else
      return (
        <input
          type="text"
          className="form-control"
          placeholder={`Value ${position + SECOND}`}
          value={propertyValue.value}
          onChange={(e) => handleOnChange(e, propertyValue)}
        />
      );
  };

  return (
    <div className="form-group">
      <label className="text-sm font-medium text-gray-50 mb-1 block capitalize">
        <div className="my-4">Values</div>
      </label>
      <div>
        {propertyValues.map((propertyValue, position) => {
          return (
            <div
              key={propertyValue.id}
              className="flex gap-2 items-center my-2"
            >
              {renderFieldIcon(fieldType, propertyValue)}
              <div
                className={classNames("w-full mx-auto my-auto", {
                  "inline-flex": fieldType === SELECT,
                })}
              >
                {renderRepeaterProperties(fieldType, propertyValue, position)}
              </div>
              <div className="delete mx-3 my-2.5 w-6 h-6 shrink-0">
                <button
                  className="hover:opacity-80 cursor-pointer disabled:cursor-not-allowed disabled:opacity-30"
                  disabled={propertyValue.isChecked}
                  onClick={() => handleDeletePropertyValue(propertyValue)}
                >
                  <img src={redTrashIcon} alt="delete" className="w-6" />
                </button>
              </div>
            </div>
          );
        })}
      </div>
      <button
        onClick={handleAddPropertyValue}
        className="btn btn-primary-light w-full"
        type="button"
      >
        Add Values
      </button>
    </div>
  );
};

export default Repeater;
